import React, { Component, useEffect, useState } from 'react'
import { CustomFormFloating } from '../../../custom-form-floating/CustomFormFloating'
import { CloseButtonModal } from './CloseButtonModal';
import logger from '../../../../../utils/logger';
import { Link } from 'react-router-dom';
import { UserProfileData } from './common-components/UserProfileData';
import { UserContactData } from './common-components/UserContactData';

export const UserData = ({ toggleModal, isActive = false, userData }) => {


    const [userInfo, setUserInfo] = useState(null)

    useEffect(() => {

        if (userData) {
            setUserInfo(userData)
        }

    }, [userData])

    logger.debug('userInfo es: ', userInfo)

    const validationFunction = (params) => {
        if (userInfo.hasOwnProperty(params)) {
            return params
        }
    };


    const [editInput, setEditInput] = useState(true)



    const editionDisable = () => {
        setEditInput(true)
    };

    useEffect(() => {

        if (isActive) {
            //? Se desactiva la edicion al cambiar de ventana dentro del modal
            editionDisable()
        }
    }, [isActive])



    return (
        <div id="content-1" className={`dto-contacto content ${isActive ? 'active' : ''}`}>





            <CloseButtonModal toggleModal={toggleModal} />



            <div className="header-dto">
                <h4 className="header-nav-title">Datos de contacto</h4>

                {/* <button className="btn-edit beEdit-1 mI-Edit" id="editButton-1" data-button="1" disabled={editInput === false ? 'disable' : ''}>
                    <span
                        className="material-icons notranslate " onClick={editionEnable}  >
                        edit
                    </span>
                </button> */}

                <UserProfileData
                    userInfo={userInfo}
                />


                <UserContactData
                    userInfo={userInfo}
                />




            </div>

            <hr className="under-header" />



            <div className="user-dto">

                {userInfo?.documentType.description &&
                    <div className="form-floating">

                        <p className="dto-title-1">Tipo de Documento</p>
                        <span className="editable-select-1" id="documentType">{userInfo.documentType.description}</span>
                        <label className="active-label-1 class-hidden-none al-2" htmlFor="documentType">Tipo de
                            Documento</label>
                        <hr className="hr-dto" />

                    </div>
                }




                {userInfo?.dni &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'Nro de Documento'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'23456789'}
                    >
                        <>
                            <p className="dto-title-1">Nro de Documento</p>
                            <span id="UserDNI" className="editable-1">{userInfo.dni}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserDNI">Nro de Documento</label>
                            <hr className="hr-dto" />
                        </>
                    </CustomFormFloating>
                }



                {userInfo?.profession.name &&
                    <div className="form-floating">


                        <p className="dto-title-1">Profesión</p>
                        <span id="UserProfession" className="editable-select-prof-1">{userInfo.profession.name}</span>
                        <label className="active-label-1 class-hidden-none al-2" htmlFor="UserProfession">Profesión</label>
                        <hr className="hr-dto" />
                    </div>
                }


                {userInfo?.professionalLicense &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'MP'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'34567890'}
                    >
                        <>
                            <p className="dto-title-1">MP</p>
                            <span id="UserMp" className="editable-1">{userInfo.professionalLicense}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserMp">MP</label>
                            <hr className="hr-dto" />
                        </>

                    </CustomFormFloating>
                }

                {userInfo?.address &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'Dirección'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'Av. Corrientes 1234'}
                    >
                        <>
                            <p className="dto-title-1">Dirección</p>
                            <span id="UserAddress" className="editable-1">{userInfo.address}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserAddress">Direccion</label>
                            <hr className="hr-dto" />
                        </>

                    </CustomFormFloating>
                }



                {userInfo?.zipCode &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'Código Postal'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'B1228'}
                    >

                        <>
                            <p className="dto-title-1">Código Postal</p>
                            <span id="UserCp" className="editable-1">{userInfo.zipCode}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserCp">Código Postal</label>
                            <hr className="hr-dto" />
                        </>
                    </CustomFormFloating>
                }


                {userInfo?.addressAdditionalData &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'Barrio'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'Palermo'}
                    >

                        <>
                            <p className="dto-title-1">Barrio</p>
                            <span id="UserNeighborhood" className="editable-1">{userInfo.addressAdditionalData}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserNeighborhood">Barrio</label>
                            <hr className="hr-dto" />
                        </>
                    </CustomFormFloating>
                }


                {userInfo?.city &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'Localidad'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'CABA'}
                    >

                        <>
                            <p className="dto-title-1">Localidad</p>
                            <span id="UserLocation" className="editable-1">{userInfo.city}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserLocation">Localidad</label>
                            <hr className="hr-dto" />
                        </>
                    </CustomFormFloating>
                }




                {userInfo?.province &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'Provincia'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'Buenos Aires'}
                    >

                        <>
                            <p className="dto-title-1">Provincia</p>
                            <span id="UserState" className="editable-1">{userInfo.province}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserState">Provincia</label>
                            <hr className="hr-dto" />
                        </>
                    </CustomFormFloating>
                }


                {userInfo?.country &&
                    <CustomFormFloating
                        status={editInput}
                        type={'text'}
                        className={'editable-admin-input w-100'}
                        label={'País'}
                        labelClassName={'active-label'}
                        hrtag={'hr-dto'}
                        value={'Argentina'}
                    >

                        <>
                            <p className="dto-title-1">País</p>
                            <span id="UserCountry" className="editable-1">{userInfo.country}</span>
                            <label className="active-label-1 class-hidden-none al-2" htmlFor="UserCountry">País</label>
                            <hr className="hr-dto" />
                        </>
                    </CustomFormFloating>
                }







                {!editInput ?
                    <div className="sc-buttons-1" id="actionButtons" >
                        <button className="btn-cancel" id="cancelButton" data-cancel="1" onClick={editionDisable}>Cancelar</button>
                        <button className="btn-save btn btn-success" id="saveButton" data-save="1">Guardar</button>
                    </div>

                    : null}

            </div>





        </div>
    )
}
